import React from "react";
import PrivacyNotice from "./PrivacyNotice";
import Announcement from "./Announcement";

interface ListItem {
  index: number;
  content: string;
}

interface TextListProps {
  listItems: ListItem[];
  loadingList: boolean;
  loadingMore: boolean;
  hasMore: boolean;
  onEditItem: (index: number) => void;
  onClearItem: (index: number) => void;
  onLoadMore: () => void;
}

const TextList: React.FC<TextListProps> = ({
  listItems,
  loadingList,
  loadingMore,
  hasMore,
  onEditItem,
  onClearItem,
  onLoadMore,
}) => {
  return (
    <>
      <PrivacyNotice />
      <Announcement storageKey="systemAnnouncementClosed" title="系统公告" icon="📢">
        由于系统升级，我们于 2025年1月20日 对数据存储密钥格式进行了优化调整。为确保数据安全，所有历史数据已重置，请重新创建您的文本条目。感谢您的理解与支持。
      </Announcement>
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          borderRadius: "16px",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
          padding: "24px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#E0E0E0" }}>
            条目列表 ({listItems.length})
          </h2>
        </div>
        {loadingList ? (
          <div style={{ textAlign: "center", padding: "40px", color: "#E0E0E0" }}>加载中...</div>
          ) : listItems.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px", color: "#E0E0E0" }}>暂无条目</div>
          ) : (
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            gap: "12px",
            maxHeight: "50vh",
            overflowY: "auto",
            paddingRight: "8px"
          }}>
            {listItems.map((item) => (
              <div
                key={item.index}
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.05)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "8px",
                  padding: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  transition: "all 0.2s",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "#00FFD1";
                  e.currentTarget.style.boxShadow = "0 0 15px rgba(0, 255, 209, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: "14px", fontWeight: "500", color: "#00FFD1", marginBottom: "4px" }}>
                    条目 #{item.index}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#E0E0E0",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.content || "(空)"}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "8px", marginLeft: "16px" }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditItem(item.index);
                    }}
                    style={{
                      padding: "6px 12px",
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#E0E0E0",
                      backgroundColor: "rgba(255, 255, 255, 0.05)",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      borderRadius: "6px",
                      cursor: "pointer",
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "#00FFD1";
                      e.currentTarget.style.boxShadow = "0 0 10px rgba(0, 255, 209, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    编辑
                  </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onClearItem(item.index);
                      }}
                      style={{
                        padding: "6px 12px",
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#FFB74D",
                        backgroundColor: "rgba(255, 152, 0, 0.1)",
                        border: "1px solid rgba(255, 152, 0, 0.3)",
                        borderRadius: "6px",
                        cursor: "pointer",
                        transition: "all 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "rgba(255, 152, 0, 0.2)";
                        e.currentTarget.style.boxShadow = "0 0 10px rgba(255, 152, 0, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "rgba(255, 152, 0, 0.1)";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      清空
                    </button>
                </div>
              </div>
            ))}
            {!loadingList && listItems.length > 0 && hasMore && (
              <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <button
                  onClick={onLoadMore}
                  disabled={loadingMore}
                  style={{
                    padding: "10px 24px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#E0E0E0",
                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    borderRadius: "8px",
                    cursor: loadingMore ? "not-allowed" : "pointer",
                    opacity: loadingMore ? 0.6 : 1,
                    transition: "all 0.2s",
                    backdropFilter: "blur(10px)",
                    WebkitBackdropFilter: "blur(10px)",
                    width: "100%",
                  }}
                  onMouseEnter={(e) => {
                    if (!loadingMore) {
                      e.currentTarget.style.borderColor = "#00FFD1";
                      e.currentTarget.style.boxShadow = "0 0 15px rgba(0, 255, 209, 0.3)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!loadingMore) {
                      e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
                      e.currentTarget.style.boxShadow = "none";
                    }
                  }}
                >
                  {loadingMore ? "加载中..." : "加载更多"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default TextList;
